export function RecordingItemSkeleton() {
  return (
    <div className="flex flex-col overflow-hidden rounded-2xl border border-border bg-card">
      {/* Dark header section */}
      <div className="relative aspect-video bg-[#111827] p-6">
        {/* Skeleton for title */}
        <div className="mb-12 flex flex-col items-center px-8">
          <div className="mb-2 h-6 w-full animate-pulse rounded bg-gray-700"></div>
          <div className="h-6 w-3/4 animate-pulse rounded bg-gray-700"></div>
        </div>

        {/* Powered by section skeleton */}
        <div className="mt-4 flex items-center justify-center">
          <div className="h-5 w-36 animate-pulse rounded bg-gray-700"></div>
        </div>
      </div>

      {/* Light details section */}
      <div className="flex flex-1 flex-col bg-background p-4">
        <div className="mb-4 flex items-center justify-between">
          {/* Time skeleton */}
          <div className="flex items-center space-x-2">
            <div className="h-5 w-5 animate-pulse rounded-full bg-gray-200"></div>
            <div className="h-5 w-14 animate-pulse rounded bg-gray-200"></div>
          </div>

          {/* Date skeleton */}
          <div className="flex items-center space-x-2">
            <div className="h-4 w-5 animate-pulse rounded-full bg-gray-200"></div>
            <div className="h-4 w-24 animate-pulse rounded bg-gray-200"></div>
          </div>

          {/* Badge skeleton */}
          <div className="h-4 w-16 animate-pulse rounded-full bg-primary-200"></div>
        </div>

        {/* User profile section skeleton */}
        <div className="flex items-center">
          {/* Avatar skeleton */}
          <div className="mr-4 h-10 w-10 animate-pulse rounded-full bg-gray-200"></div>

          {/* User info skeleton */}
          <div className="space-y-2">
            <div className="h-4 w-40 animate-pulse rounded bg-gray-200"></div>
            <div className="h-4 w-32 animate-pulse rounded bg-gray-200"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
